export default __webpack_public_path__ + "static/media/aide.85c8752c.svg";